import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    imageContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    infoRow: {
        flexDirection: "column"
    },
    unselectableText: {
        userSelect: "none"
    },
    container: {
        maxHeight: "80%",
        maxWidth: "90%",
        zIndex: 999999,
        width: 400
    },
    scrollContent: {
    },
    profileImage: {
        height: 100,
        width: 100
    },
    scroll: {
    }
});

export default stylesheet;
